import { createRoute, defer, redirect } from '@tanstack/react-router'

import { rootRoute } from '@/routes/root'
import { ensureAuthenticatedUser } from '@/utils/auth-wall'

import { organizationsQueryOptions } from './api/master-data.service'
import { CompanyAccountErrorComponent, CompanyAccountSkeleton } from './view/companyAccountLayout'

export const companyAccountRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/company/account',
  errorComponent: CompanyAccountErrorComponent,
  pendingComponent: CompanyAccountSkeleton,
  beforeLoad: async ({ context, location }) => {
    await ensureAuthenticatedUser({ context, location })
    if (context.isReady && !context.isCustomerActive) {
      throw redirect({
        to: '/',
      })
    }
  },
  loader: async ({ context }) => {
    if (!context.queryClient) return
    const customerID = context.customer?._id || ''
    const organizations = context.queryClient?.ensureQueryData(organizationsQueryOptions(customerID))
    return { organizations: defer(organizations) }
  },
}).lazy(() => import('./view/companyAccountRoot').then((d) => d.Route))
